import React from "react";
import {
  Route,
  RouteProps,
  Redirect,
  RouteComponentProps,
} from "react-router-dom";

import AuthContext from "./AuthContext";

const ProtectedRoute: React.FC<
  RouteProps & { children: (props: RouteComponentProps) => React.ReactElement }
> = ({ children, ...rest }) => {
  const authContext = React.useContext(AuthContext);
  return (
    <Route
      path={rest.path}
      render={(props) => {
        return authContext!.isAuthenticated ? (
          children(props)
        ) : (
          <Redirect
            to={{
              pathname: "/auth/login",
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};

export default ProtectedRoute;
